import { ChevronLeft, ChevronsLeft } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ChevronLeftIcon = DeckardIconWrapper({ Icon: ChevronLeft, DoubleIcon: ChevronsLeft });
